module.exports = __webpack_public_path__ + "static/media/DSC_0138.3107ed5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0138.jpg
// module id = 635
// module chunks = 0